import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import LiveMobilePosButton from "./LiveMobilePosButton";
import LiveSound from "./LiveSound";

const LiveMenuDesktop = () => {
  const isMobile = useIsMobileHook();
  return isMobile ? null : (
    <>
      <LiveSound />
      <LiveMobilePosButton />
    </>
  );
};

export default LiveMenuDesktop;
